import { inject } from "inversify";
import { ISessionService, ISessionServiceId } from "../services";
import { IMessagingServiceId, IMessagingService } from "../services";

class ComponentPage {

    protected pageEl: HTMLElement;
    protected urlParams: URLSearchParams;

    public id: string;
    public isAuthenticated: boolean;

    constructor(
        pageEl: HTMLElement,
        @inject(IMessagingServiceId) private messagingService: IMessagingService,
        @inject(ISessionServiceId) private sessionService: ISessionService) {

        this.pageEl = pageEl;
        this.id = pageEl.id;
        this.urlParams = new URLSearchParams(location.search);
        
        this.sessionService.StartSession();
    }
    
}

export { ComponentPage }